import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { RegisterComponent } from './register/register.component';
import { StartupPageComponent } from './startup-page/startup-page.component';
import { AuthGuard } from './guards/auth-guard.service';
import { LogoutSsoComponent } from './logout-sso/logout-sso.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'forget-password', component: ForgetPasswordComponent },
  { path: 'login/set-password', component: SetPasswordComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'logoutsso', component: LogoutSsoComponent },
  { path: 'StartupPage', component: StartupPageComponent ,canActivate: [AuthGuard]},
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
